export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q01_a.03517025.png";